const NotaMABStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Compila i seguenti campi",
                id: "notaMabForm",
                description: "Sezione dedicata ai comitato e alla nota MAB",
                multipleValue: false,
                rows : [
                {
                    id : "row1",
                    fields : [
                        {
                            name: "titoloNota",
                            type: "textRevisione",
                            numColMd: 6,
                            label: "Titolo Nota MAB (CMAB_Nome)",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "esitoProposto",
                            type: "choiceRevisione",
                            numColMd: 6,
                            label: "Esito Proposto",
                            required: false,
                            tooltipText: "",
                            choiceList : [
                                'Avvio',
                                'Non Avvio',
                                'Sospensione',
                                'Da Ritirare'
                            ],
                        }
                    ]
                },
                {
                    id : "row2",
                    fields : [
                        {
                            name: "suspiciousTypeMab",
                            type: "multiListRevisione",
                            numColMd: 12,
                            label: "Ipotesi di Abuso Nota MAB",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                        },
                    ]
                },
                {
                    id : "row3",
                    fields : [
                        {
                            name: "notaMab",
                            type: "textArea",
                            numColMd: 12,
                            label: "Nota - Altro (Opzionale)",
                            required: false,
                            tooltipText: "",
                        },
                    ]
                },
                {
                    id : "row4",
                    fields : [
                        {
                            name: "numeroPredisposizione",
                            type: "textReviosionata",
                            numColMd: 4,
                            label: "Numero Predisposizione",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "numeroRiunione",
                            type: "textReviosionata",
                            numColMd: 4,
                            label: "Numero Riunione (CMAB_ANNO_ID)",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "dataPrimaRiunione",
                            type: "dateRevisionata",
                            numColMd: 4,
                            label: "Data Prima Riunione",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                },
                {
                    id : "row5",
                    fields : [
                        {
                            name: "noteSegreteria",
                            type: "textAreaSegreteria",
                            numColMd: 12,
                            label: "Nota Segreteria (Opzionale)",
                            required: false,
                            tooltipText: "",
                        },
                    ]
                }
            ]}  
        }
    }
}

export default NotaMABStructure;